import React from "react";

const NoMessageIcon = () => (
  <svg
    width="384"
    height="300"
    viewBox="0 0 384 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="93" y="60" width="243" height="127" rx="22" fill="#F5F5F5" />
    <rect x="132" y="97" width="80" height="9" rx="4.5" fill="#E0E0E0" />
    <g filter="url(#filter0_dd_21173_73594)">
      <rect x="51" y="123" width="243" height="127" rx="22" fill="#CCDCF7" />
    </g>
    <rect x="79" y="170" width="80" height="9" rx="4.5" fill="#F5F5F5" />
    <rect x="79" y="195" width="163" height="9" rx="4.5" fill="#F5F5F5" />
    <circle cx="49.5" cy="30.5" r="7.5" stroke="#82B1FF" strokeWidth="2" />
    <circle cx="271" cy="7" r="6" stroke="#82B1FF" strokeWidth="2" />
    <circle
      cx="354"
      cy="206"
      r="6"
      fill="#E0E0E0"
      stroke="#E0E0E0"
      strokeWidth="2"
    />
    <circle
      cx="7"
      cy="113"
      r="6"
      fill="#E0E0E0"
      stroke="#E0E0E0"
      strokeWidth="2"
    />
    <rect x="159" y="11" width="2" height="12" rx="1" fill="#E3F2FD" />
    <rect
      x="166"
      y="16"
      width="2"
      height="12"
      rx="1"
      transform="rotate(90 166 16)"
      fill="#E3F2FD"
    />
    <rect x="377" y="79" width="2" height="12" rx="1" fill="#E3F2FD" />
    <rect
      x="384"
      y="84"
      width="2"
      height="12"
      rx="1"
      transform="rotate(90 384 84)"
      fill="#E3F2FD"
    />
    <rect x="19" y="192" width="2" height="12" rx="1" fill="#E3F2FD" />
    <rect
      x="26"
      y="197"
      width="2"
      height="12"
      rx="1"
      transform="rotate(90 26 197)"
      fill="#E3F2FD"
    />
    <defs>
      <filter
        id="filter0_dd_21173_73594"
        x="18"
        y="90"
        width="309"
        height="194"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-3" dy="4" />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_21173_73594"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="-3" />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_21173_73594"
          result="effect2_dropShadow_21173_73594"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_21173_73594"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
NoMessageIcon.defaultProps = {
  className: "",
  color: "",
};

export default NoMessageIcon;
